import React from 'react'
import Home from '../pages/home'
import About from '../pages/about'
import ContactForm from '../pages/contact'
import Projects from '../pages/projects'
import SuccessPage from '../pages/Success'
import {Routes,Route,BrowserRouter} from 'react-router-dom'

export default function Routers() {
  return (
      <BrowserRouter>
      <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/contact' element={<ContactForm/>}/>
      <Route path='/projects' element={<Projects/>}/>
      <Route path='/success' element={<SuccessPage/>}/>
      </Routes>
      </BrowserRouter>
    
  )
}
